import React from "react";
import { cn } from "utils";
import { Icon } from "@ospweb/sdk-ui";
import { ResultsDropdown } from "./ResultsDropdown";
import { SearchInputProps } from "./types";
import Translations from "@translate/components/Portfolio/Search/MobileSearchDrawer";
import { I18nUtil } from "@utils/i18n";
import { DrawerH5 } from "@/src/components/DrawerH5";

const I18n = I18nUtil.createScoped(Translations);

interface MobileSearchDrawerProps extends Omit<
  SearchInputProps,
  "closing" | "showDropdown"
> {
  open: boolean;
  onClose: () => void;
  loading?: boolean;
}

/**
 * MobileSearchDrawer
 * - 移动端搜索抽屉组件
 * - 固定搜索框在顶部，结果区域可滚动
 * - 内容自适应高度，最大 60dvh
 */
export const MobileSearchDrawer: React.FC<MobileSearchDrawerProps> = ({
  open,
  onClose,
  keywords,
  onChange,
  onCancel,
  inputRef,
  results,
  onSelect,
  hasMore,
  onLoadMore,
  loading = false,
}) => (
  <DrawerH5 open={open} onClose={onClose}>
    <div className="flex flex-col h-[min(60dvh,600px)]">
      <div className="flex items-center gap-3 p-4 sticky top-0 bg-background_solid_secondary z-10">
        <div className="flex items-center h-10 px-3 bg-background_white_overlay5 border border-border_white_transparent5 rounded-2 flex-1">
          <Icon name="search" size={20} className="text-content_primary" />
          <input
            ref={inputRef}
            placeholder="Search"
            aria-label="Search"
            className={cn(
              "ml-2 flex-1 h-full body_m text-content_primary caret-content_brand_primary bg-transparent border-0 outline-none",
              "placeholder:text-content_quaternary focus:outline-none focus:ring-0",
            )}
            value={keywords}
            onChange={onChange}
          />
        </div>
        <button
          aria-label="Mobile Search Drawer"
          data-openreplay-label={`Mobile Search Drawer Button | ${I18n.t("Cancel")}`}
          id="btn-mobile-search-drawer"
          type="button"
          className="button_m text-content_tertiary"
          onClick={onCancel}
        >
          {I18n.t("Cancel")}
        </button>
      </div>

      {/* 移动端结果区 */}
      <div className="flex-1 overflow-y-auto no-scrollbar">
        {keywords && (
          <ResultsDropdown
            results={results}
            loading={loading}
            className="static w-full border-0 px-6 pt-0 pb-4 shadow-none mt-0"
            onSelect={onSelect}
            hasMore={hasMore}
            onLoadMore={onLoadMore}
          />
        )}
      </div>
    </div>
  </DrawerH5>
);
